import './Recommendations.css';

import {
  Alert,
  AlertItem,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalTitle
} from '@vmware-react/clarity';
import React, { FC } from 'react';
import ReactDOM from 'react-dom';
import { l10n } from '../with-app-root/i18n/i18nUtil';

interface Props {
  open: boolean;
  recommendations: string[];
  onClose: () => void;
}

const Recommendations: FC<Props> = props => {
  const { open, recommendations, onClose } = props;

  function renderBody() {
    return (
      <ModalBody>
        {recommendations.length > 0 ? (
          <ol className="precheck_recommendations__list">
            {recommendations.map((rec, i) => {
              const urlMatch = rec.match(/https:(.*)html/g);
              if (urlMatch) {
                rec = rec.replace(/https:(.*)html/g, '');
              }
              return (
                <li key={i}>
                  {rec}
                  {urlMatch && (
                    <span>
                      <a
                        href={urlMatch[0]}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {l10n('documentation')}
                      </a>
                    </span>
                  )}
                </li>
              );
            })}
          </ol>
        ) : (
          <Alert
            ariaLiveMsg={l10n('components.preCheck.noAvailableRecommendations')}
            items={[
              <AlertItem>
                {l10n('components.preCheck.noAvailableRecommendations')}
              </AlertItem>
            ]}
            type="info"
          />
        )}
      </ModalBody>
    );
  }

  function renderFooter() {
    return (
      <ModalFooter>
        <Button class="primary" size="sm" onClick={onClose}>
          {l10n('ok')}
        </Button>
      </ModalFooter>
    );
  }

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.keyCode === 27) {
      e.stopPropagation();
    }
  };

  return ReactDOM.createPortal(
    <div onKeyDown={onKeyDown}>
      <Modal
        size="md"
        visible={open}
        closable={true}
        title={<ModalTitle>{l10n('recommendations')}</ModalTitle>}
        body={renderBody()}
        footer={renderFooter()}
        onCloseClick={onClose}
        onBackdropClick={onClose}
      />
    </div>,
    document.body
  );
};

export default Recommendations;
